import React, { useState } from "react";
import { FaFileUpload } from "react-icons/fa";
import instance from "../../../api/axios";

const EditCollaborator = ({ event, onClose, onUpdate }) => {

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const d = new Date(dateString);
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    const year = d.getFullYear();
    return `${year}-${month}-${day}`;
  };

  const [formData, setFormData] = useState({
    ...event,
    startdate: formatDate(event.startdate),
    enddate: formatDate(event.enddate),
    uploadPhoto: null,
  });


  const [errors, setErrors] = useState({});
  const [imageName, setImageName] = useState("");

  // Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    validateField(name, value);
  };

  // Validate individual field
  const validateField = (name, value) => {
    let error = "";
    switch (name) {
      case "organizationName":
        if (!value.trim()) error = "Organization Name is required.";
        break;
      case "startdate":
        if (new Date(value) < new Date("2017-01-01"))
          error = "Start date must be from 2017 onwards.";
        break;
      case "enddate":
        if (formData.renewalStatus === "Yes" && new Date(value) <= new Date(formData.startdate))
          error = "End date must be after the start date.";
        break;
      default:
        break;
    }
    setErrors(prev => ({ ...prev, [name]: error }));
  };

  // Handle image selection
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const allowedTypes = ["image/jpeg", "image/jpg"];
    if (!allowedTypes.includes(file.type)) {
      console.error("Please upload a valid image file (.jpg or .jpeg).");
      return;
    }
    setImageName(file.name);
    setFormData(prev => ({ ...prev, uploadPhoto: file }));
  };

  // Handle Save
  const handleSave = async () => {
    const validationErrors = {};
    Object.keys(formData).forEach(field => validateField(field, formData[field]));
    Object.keys(errors).forEach(field => {
      if (errors[field]) validationErrors[field] = errors[field];
    });
    if (Object.keys(validationErrors).length > 0) return;

    try {
      const sendData = new FormData();
      sendData.append("organizationName", formData.organizationName);
      sendData.append("startdate", new Date(formData.startdate).toISOString()); // convert to ISO
      if (formData.renewalStatus === "Yes")
        sendData.append("enddate", new Date(formData.enddate).toISOString()); // convert to ISO

      if (formData.uploadPhoto) sendData.append("image", formData.uploadPhoto);
      else if (event.image_url) sendData.append("image_url", event.image_url);

      const response = await instance.put(
        `/api/CollaborationImgAWS/${event.projectNo}`,
        sendData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      const updatedData = {
        ...event,
        organizationName: formData.organizationName,
        startdate: new Date(formData.startdate).toISOString(),
        enddate: formData.renewalStatus === "Yes" ? new Date(formData.enddate).toISOString() : event.enddate,
        image_url: response.data.image_url || event.image_url,
        projectNo: event.projectNo
      };

      onUpdate(updatedData);
      onClose();
    } catch (err) {
      console.error("Update error:", err);
    }
  };

  

  return (
    <div className="flex flex-col items-start justify-start w-[750px] rounded-3xl text-black font-poppins">
      <form className="w-full bg-color p-6 rounded-xl shadow-lg">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
          {/* Left side */}
          <div className="space-y-6">
            <div>
              <label className="block mb-2 font-bold text-white">Organization Name*</label>
              <input
                type="text"
                name="organizationName"
                value={formData.organizationName}
                onChange={handleChange}
                className="w-full h-[45px] border border-gray-300 rounded-md px-3"
                placeholder="Enter Organization Name"
              />
              {errors.organizationName && <p className="text-red-500 text-sm">{errors.organizationName}</p>}
            </div>

            <div>
              <label className="block mb-2 font-bold text-white">Start Date*</label>
              <input
                type="date"
                name="startdate"
                value={formData.startdate}
                onChange={handleChange}
                min="2017-01-01"
                className="w-full h-[45px] border border-gray-300 rounded-md px-3"
              />
              {errors.startdate && <p className="text-red-500 text-sm">{errors.startdate}</p>}
            </div>

            <div>
              <label className="block mb-2 font-bold text-white">End Date*</label>
              <input
                type="date"
                name="enddate"
                value={formData.enddate}
                onChange={handleChange}
                min={formData.startdate || "2017-01-01"}
                className={`w-full h-[45px] border border-gray-300 rounded-md px-3 ${formData.renewalStatus !== "Yes" ? "bg-gray-200 cursor-not-allowed" : ""
                  }`}
                disabled={formData.renewalStatus !== "Yes"}
              />
              {errors.enddate && <p className="text-red-500 text-sm">{errors.enddate}</p>}
            </div>
          </div>

          {/* Right side - Image */}
          <div className="flex flex-col items-end space-y-4">
            <div className="w-[150px] h-[150px] border border-gray-300 rounded-lg overflow-hidden bg-white">
              {event.image_url && <img src={event.image_url} alt="Current logo" className="w-full h-full object-contain" />}
            </div>

            <div className="flex flex-col items-center">
              <div className="relative w-[150px] h-[150px] border-2 border-dashed border-gray-300 rounded-lg flex flex-col items-center justify-center bg-white hover:border-blue-500">
                <FaFileUpload className="w-8 h-8 text-gray-400 mb-2" />
                <label className="text-gray-600 text-sm cursor-pointer hover:text-blue-500">
                  Upload New Logo
                  <input
                    type="file"
                    accept="image/jpeg,image/jpg"
                    className="hidden"
                    onChange={handleImageChange}
                  />
                </label>
              </div>
              {imageName && <p className="text-gray-600 text-xs mt-2 truncate max-w-[150px]">{imageName}</p>}
            </div>
          </div>
        </div>

        <div className="flex justify-center mt-6">
          <button type="button" onClick={onClose} className="bg-black text-white py-2 px-6 rounded-lg mr-4">
            Cancel
          </button>
          <button type="button" onClick={handleSave} className="bg-black text-white py-2 px-6 rounded-lg">
            Save
          </button>
        </div>
      </form>
    </div>
  );
};

export default EditCollaborator;
